import { highlightSearchMatch } from '@components'

import { Flex } from '@billy/design-system'
import { Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import type { ExpertProfitAndLossLevel } from '../../../../types/expertProfitAndLossReport'
import type { ExpertProfitAndLossRowKind } from '../../../../types/expertProfitAndLossView'
import * as Styled from './styles'

interface ProfitAndLossLabelProps {
  kind: ExpertProfitAndLossRowKind
  label: string
  level?: ExpertProfitAndLossLevel
  searchTerm?: string
}

export const ProfitAndLossLabel = ({ kind, label, level, searchTerm = '' }: ProfitAndLossLabelProps): ReactElement => {
  if (kind === 'heading') {
    return (
      <Styled.HeadingLabel isNested={level === 3}>
        <Typography.Text title={label} weight="semibold">
          {highlightSearchMatch(label, searchTerm)}
        </Typography.Text>
      </Styled.HeadingLabel>
    )
  }

  const isHighlighted = kind === 'result' || kind === 'subtotal'

  const text = (
    <Typography.Text title={label} weight={isHighlighted ? 'semibold' : 'regular'}>
      {highlightSearchMatch(label, searchTerm)}
    </Typography.Text>
  )

  if (isHighlighted) {
    return (
      <Flex data-testid="profit-and-loss-label-highlighted" justifyContent="flex-end" width="100%">
        {text}
      </Flex>
    )
  }

  return text
}
